export default "__VITE_ASSET__2c81831f__"